import React, { useContext, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { useNavigate } from "react-router-dom";
import { StoreImageComponent } from "../Host/Imagecomponent";
import { Navigate } from "react-router-dom";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import AuthContext from "context/AuthContext";
import { Alert } from "react-bootstrap";
import { passwordRegExp } from "../Host/SignupForm";
import { base64Decode } from "@firebase/util";

import "./signupC.css";
const LoginSchema = Yup.object().shape({
  firstName: Yup.string()
    .min(2, "Mininum 2 characters")
    .max(15, "Maximum 15 characters")
    .required("Required!"),
  lastName: Yup.string()
    .min(2, "Mininum 2 characters")
    .max(15, "Maximum 15 characters")
    .required("Required!"),
  email: Yup.string()
    .email("Invalid email address format")
    .required("Email is required"),
  password: Yup.string()
    .matches(
      passwordRegExp,
      "Must have 8 characters at least with number and a special character"
    )
    .required("Password is required"),
  minAmount: Yup.number().required("Required!"),
  storeName: Yup.string().min(1, "Mininum 1 characters").required("Required!"),
  confirmPassword: Yup.string()
    .when("password", {
      is: (val) => (val && val.length > 0 ? true : false),
      then: Yup.string().oneOf(
        [Yup.ref("password")],
        "Both password need to be the same"
      ),
    })
    .required("password is required"),
});

const FormColumn = (props) => {
  let { user, signUpUser, signupErrors, setSignupErrors, shopifyThreshold } =
    useContext(AuthContext);
  const [password, setPassword] = useState(true);
  const [password2, setPassword2] = useState(true);
  const navigate = useNavigate();
  const queryParams = new URLSearchParams(window.location.search);
  if (user) {
    return <Navigate to="/user/welcome" />;
  } else {
    return (
      <div className="container store-signup-wrap">
        <div className="row">
          <div className="col-md-6">
            <p
              style={{
                fontSize: "25px",
                textAlign: "left",
                fontWeight: "bold",
                marginTop: "50px",
              }}
            >
              Create your company account
            </p>
            <p className="account-already">
              Already have an account?{" "}
              <span
                onClick={() => navigate("/store-login")}
                className="login-link"
              >
                Log in
              </span>
            </p>
            <Formik
              initialValues={{
                email: `${
                  queryParams.get("invite")
                    ? base64Decode(queryParams.get("invite"))
                    : ""
                }`,
                password: "",
                confirmPassword: "",
                firstName: "",
                lastName: "",
                minAmount: "",
                storeName: `${
                  queryParams.get("store_name")
                    ? queryParams.get("store_name")
                    : ""
                }`,
                store_id: `${
                  queryParams.get("store_id") ? queryParams.get("store_id") : ""
                }`,
                role: 2,
              }}
              onSubmit={(data, { setSubmitting }) => {
                var body = {
                  email: data.email,
                  password: data.password,
                  confirm_password: data.confirmPassword,
                  first_name: data.firstName,
                  last_name: data.lastName,
                  minimum_amount: data.minAmount,
                  store_name: `${
                    queryParams.get("store_name")
                      ? queryParams.get("store_name")
                      : ""
                  }`,
                  store_id: `${
                    queryParams.get("store_id")
                      ? queryParams.get("store_id")
                      : ""
                  }`,
                  role: 2,
                };
                const bodys = {
                  shop_id: parseInt(queryParams.get("store_id")),
                  threshold_amount: data.minAmount,
                };
                const shopify = shopifyThreshold(bodys);

                shopify
                  .then(function (response) {
                    if (response.status === 200) {
                      const signupResponse = signUpUser(body);
                      signupResponse
                        .then(function (response) {
                          if (response.status === 201) {
                            navigate("/store-login", {
                              state: {
                                changedPassword:
                                  "Check your email for verification",
                                variant: "success",
                                email: data.email,
                              },
                            });
                            setSubmitting(false);
                          }
                        })
                        .catch(function (error) {
                          setSubmitting(false);
                        });
                    }
                  })
                  .catch(function (error) {
                    setSubmitting(false);
                    setSignupErrors(error.response.data.message);
                  });
              }}
              validationSchema={LoginSchema}
            >
              {({ touched, errors, isSubmitting }) => (
                <Form>
                  <div className="row">
                    <div className="col-md-12">
                      {signupErrors ? (
                        <Alert className="" key="danger" variant="danger">
                          {signupErrors}
                        </Alert>
                      ) : (
                        <></>
                      )}
                    </div>
                    <div className="col-md-6 mb-3">
                      <Field
                        type="text"
                        name="firstName"
                        placeholder="First Name"
                        className={`form-control ${
                          touched.firstName && errors.firstName
                            ? "is-invalid"
                            : ""
                        }`}
                      />
                      <ErrorMessage
                        component="div"
                        name="firstName"
                        className="invalid-feedback"
                      />
                    </div>

                    <div className="col-md-6 mb-3">
                      <Field
                        type="text"
                        name="lastName"
                        placeholder="Last Name"
                        className={`form-control ${
                          touched.lastName && errors.lastName
                            ? "is-invalid"
                            : ""
                        }`}
                      />
                      <ErrorMessage
                        component="div"
                        name="lastName"
                        className="invalid-feedback"
                      />
                    </div>

                    <div className="col-md-12 mb-3">
                      <Field
                        type="email"
                        name="email"
                        placeholder="Enter email"
                        className={`form-control ${
                          touched.email && errors.email ? "is-invalid" : ""
                        }`}
                      />
                      <ErrorMessage
                        component="div"
                        name="email"
                        className="invalid-feedback"
                      />
                    </div>

                    <div className="col-md-6 mb-3">
                      <div className="password-enter-wrapper">
                        <Field
                          type={`${password ? "password" : "text"}`}
                          name="password"
                          placeholder="Enter password"
                          className={`form-control ${
                            touched.password && errors.password
                              ? "is-invalid"
                              : ""
                          }`}
                        />
                        <ErrorMessage
                          component="div"
                          name="password"
                          className="invalid-feedback"
                        />
                        <div
                          className="password-visibility"
                          onClick={() => setPassword(!password)}
                        >
                          {password ? (
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="38"
                              height="38"
                              viewBox="0 0 38 38"
                            >
                              <path d="M2.03381935,11.8192361 C4.16808919,6.31506648 10.3602678,3.58322297 15.8644374,5.71749281 C18.6654288,6.80359152 20.8800819,9.01824467 21.9661807,11.8192361 C22.0112731,11.9355272 22.0112731,12.0644728 21.9661807,12.1807639 C19.8319108,17.6849335 13.6397322,20.416777 8.1355626,18.2825072 C5.3345712,17.1964085 3.11991805,14.9817553 2.03381935,12.1807639 C1.98872688,12.0644728 1.98872688,11.9355272 2.03381935,11.8192361 Z M8.49709046,17.3501459 C13.4256883,19.2612348 18.9628618,16.8680219 20.9616531,12.0000475 C19.9532865,9.54665483 17.9813179,7.6108696 15.5029095,6.64985412 C10.5743117,4.73876518 5.0371382,7.13197809 3.03834692,11.9999525 C4.04671349,14.4533452 6.01868212,16.3891304 8.49709046,17.3501459 Z M12,16 C9.790861,16 8,14.209139 8,12 C8,9.790861 9.790861,8 12,8 C14.209139,8 16,9.790861 16,12 C16,14.209139 14.209139,16 12,16 Z M12,15 C13.6568542,15 15,13.6568542 15,12 C15,10.3431458 13.6568542,9 12,9 C10.3431458,9 9,10.3431458 9,12 C9,13.6568542 10.3431458,15 12,15 Z" />
                            </svg>
                          ) : (
                            <svg
                              fill="none"
                              height="38"
                              stroke-width="1.5"
                              viewBox="0 0 38 38"
                              width="38"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M3 3L21 21"
                                stroke="currentColor"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                              <path
                                d="M10.5 10.6771C10.1888 11.0296 10 11.4928 10 12C10 13.1045 10.8954 14 12 14C12.5072 14 12.9703 13.8112 13.3229 13.5"
                                stroke="currentColor"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                              <path
                                d="M7.36185 7.5611C5.68002 8.73968 4.27894 10.4188 3 12C4.88856 14.991 8.2817 18 12 18C13.5499 18 15.0434 17.4772 16.3949 16.6508"
                                stroke="currentColor"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                              <path
                                d="M12 6C16.0084 6 18.7015 9.1582 21 12C20.6815 12.5043 20.3203 13.0092 19.922 13.5"
                                stroke="currentColor"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                            </svg>
                          )}
                        </div>
                      </div>
                    </div>

                    <div className="col-md-6 mb-3">
                      <div className="password-enter-wrapper">
                        <Field
                          type={`${password2 ? "password" : "text"}`}
                          name="confirmPassword"
                          placeholder="Confirm password"
                          className={`form-control ${
                            touched.confirmPassword && errors.confirmPassword
                              ? "is-invalid"
                              : ""
                          }`}
                        />
                        <ErrorMessage
                          component="div"
                          name="confirmPassword"
                          className="invalid-feedback"
                        />
                        <div
                          className="password-visibility"
                          onClick={() => setPassword2(!password2)}
                        >
                          {password2 ? (
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="38"
                              height="38"
                              viewBox="0 0 38 38"
                            >
                              <path d="M2.03381935,11.8192361 C4.16808919,6.31506648 10.3602678,3.58322297 15.8644374,5.71749281 C18.6654288,6.80359152 20.8800819,9.01824467 21.9661807,11.8192361 C22.0112731,11.9355272 22.0112731,12.0644728 21.9661807,12.1807639 C19.8319108,17.6849335 13.6397322,20.416777 8.1355626,18.2825072 C5.3345712,17.1964085 3.11991805,14.9817553 2.03381935,12.1807639 C1.98872688,12.0644728 1.98872688,11.9355272 2.03381935,11.8192361 Z M8.49709046,17.3501459 C13.4256883,19.2612348 18.9628618,16.8680219 20.9616531,12.0000475 C19.9532865,9.54665483 17.9813179,7.6108696 15.5029095,6.64985412 C10.5743117,4.73876518 5.0371382,7.13197809 3.03834692,11.9999525 C4.04671349,14.4533452 6.01868212,16.3891304 8.49709046,17.3501459 Z M12,16 C9.790861,16 8,14.209139 8,12 C8,9.790861 9.790861,8 12,8 C14.209139,8 16,9.790861 16,12 C16,14.209139 14.209139,16 12,16 Z M12,15 C13.6568542,15 15,13.6568542 15,12 C15,10.3431458 13.6568542,9 12,9 C10.3431458,9 9,10.3431458 9,12 C9,13.6568542 10.3431458,15 12,15 Z" />
                            </svg>
                          ) : (
                            <svg
                              fill="none"
                              height="38"
                              stroke-width="1.5"
                              viewBox="0 0 38 38"
                              width="38"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M3 3L21 21"
                                stroke="currentColor"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                              <path
                                d="M10.5 10.6771C10.1888 11.0296 10 11.4928 10 12C10 13.1045 10.8954 14 12 14C12.5072 14 12.9703 13.8112 13.3229 13.5"
                                stroke="currentColor"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                              <path
                                d="M7.36185 7.5611C5.68002 8.73968 4.27894 10.4188 3 12C4.88856 14.991 8.2817 18 12 18C13.5499 18 15.0434 17.4772 16.3949 16.6508"
                                stroke="currentColor"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                              <path
                                d="M12 6C16.0084 6 18.7015 9.1582 21 12C20.6815 12.5043 20.3203 13.0092 19.922 13.5"
                                stroke="currentColor"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                            </svg>
                          )}
                        </div>
                      </div>
                    </div>
                    <p>
                      Use 8 or more characters with a mix of letters, numbers
                      and charactes
                    </p>
                    <div className="col-md-12 mb-3">
                      <Field
                        type="text"
                        name="storeName"
                        placeholder="Store name"
                        disabled
                        className={`form-control ${
                          touched.storeName && errors.storeName
                            ? "is-invalid"
                            : ""
                        }`}
                      />
                      <ErrorMessage
                        component="div"
                        name="storeName"
                        className="invalid-feedback"
                      />
                    </div>
                    <div className="col-md-6 mb-3">
                      <Field
                        type="number"
                        name="minAmount"
                        placeholder="$ 0.00"
                        className={`form-control ${
                          touched.minAmount && errors.minAmount
                            ? "is-invalid"
                            : ""
                        }`}
                      />
                      <ErrorMessage
                        component="div"
                        name="minAmount"
                        className="invalid-feedback"
                      />
                    </div>
                    <p>
                      Minimum value of products from your store that can be Hosted (ie. $100 allows hosting any product that is $100 or more on your site).
                    </p>
                  </div>
                  <button
                    type="submit"
                    className="btn btn-primary btn-block"
                    disabled={isSubmitting}
                  >
                    {isSubmitting ? "Please wait..." : "Submit"}
                  </button>
                </Form>
              )}
            </Formik>
          </div>

          <div className="col-md-6">
            <StoreImageComponent />
          </div>
        </div>
      </div>
    );
  }
};

export default FormColumn;
